import Axios from 'axios'
const BaseURL = process.env.VUE_APP_BASE_URL

export default {
    name: 'bank',
    state: {
        bankList: []
    },
    getters: {
        getBank: state => {
            return state.bankList
        }
    },
    mutations: {
        ADD_BANK: (state, payload) => {
            state.bankList = payload
        }
    },
    actions: {
        Fetch_Bank(store) {
            return Axios({
                method: "get",
                url: BaseURL + "./json/bank.json"
            }).then(response => {
                store.commit('ADD_BANK', response.data);
            }).catch(err => {
                return err
            });
        },
    }
}